import { Controller } from "@hotwired/stimulus"

export default class AddressController extends Controller {
  static targets = [
    "address",
    "city",
    "state",
    "country",
    "postalCode"
  ]

  connect() {
    if (!globalThis.google || !google.maps?.places) {
      console.error("Google Places API not loaded")
      return
    }

    this._placeId = null
    this._selectedAddress = null

    this.setupAutocomplete()
    this.setupManualEditDetection()
  }

  setupAutocomplete() {
    this.autocomplete = new google.maps.places.Autocomplete(this.addressTarget, {
      types: ["geocode"],
      fields: ["place_id", "address_components", "formatted_address", "geometry"]
    })

    this.autocomplete.addListener("place_changed", () => {
      const place = this.autocomplete.getPlace()
      if (!place?.address_components) return

      this._placeId = place.place_id
      this._selectedAddress = place.formatted_address

      const components = this.extractComponents(place.address_components)

      const addressLine1 = [components.streetNumber, components.route]
        .filter(Boolean)
        .join(" ")

      this.addressTarget.value =
        addressLine1 || place.formatted_address || ""

      if (this.hasCityTarget) this.cityTarget.value = components.city || ""
      if (this.hasStateTarget) this.stateTarget.value = components.state || ""
      if (this.hasCountryTarget) this.countryTarget.value = components.country || ""
      if (this.hasPostalCodeTarget) this.postalCodeTarget.value = components.postalCode || ""

      if (!components.postalCode && place.geometry && this.hasPostalCodeTarget) {
        this.lookupPostalCode(place.geometry.location)
      }

      $(this.addressTarget).data("address-selected", true)
      $(this.addressTarget)?.closest('form')?.valid()
    })
  }

  setupManualEditDetection() {
    this.addressTarget.addEventListener("input", () => {
      if (this.addressTarget.value !== this._selectedAddress) {
        this._placeId = null
      }
    })
  }

  extractComponents(components) {
    const result = {
      streetNumber: "",
      route: "",
      city: "",
      state: "",
      country: "",
      postalCode: ""
    }

    for (const component of components) {
      const t = component.types

      if (t.includes("street_number")) result.streetNumber = component.long_name
      if (t.includes("route")) result.route = component.long_name
      if (t.includes("locality") || t.includes("sublocality_level_1")) {
        result.city ||= component.long_name
      }
      if (t.includes("administrative_area_level_1")) result.state = component.long_name
      if (t.includes("country")) result.country = component.long_name
      if (t.includes("postal_code")) result.postalCode = component.long_name
    }

    return result
  }

  lookupPostalCode(location) {
    const geocoder = new google.maps.Geocoder()

    geocoder.geocode({ location }, (results, status) => {
      if (status !== "OK" || !results?.length) return

      const fallback = this.extractComponents(results[0].address_components)

      if (fallback.postalCode) {
        this.postalCodeTarget.value = fallback.postalCode
        $(this.postalCodeTarget).valid?.()
      }
    })
  }

  validateAddress() {
    if (!this._placeId) {
      this.addressTarget.value = ""
    }

    $(this.addressTarget).valid?.()
  }
}
